goog.provide("shadow.js.shim.module$react_use$lib$useTitle");
goog.provide("module$shadow_js_shim_module$react_use$lib$useTitle");
shadow.js.shim.module$react_use$lib$useTitle = shadow.js.nativeProvides["react-use/lib/useTitle"] = shadow$bridge("react-use/lib/useTitle");
module$shadow_js_shim_module$react_use$lib$useTitle.default = shadow.js.shim.module$react_use$lib$useTitle;
